import { useState } from "react";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import SectionCard from "@/components/customers/SectionCard";
import { linkLabelFromUrl, type FreelancerListRow } from "@/lib/freelancers";

const VISIBLE = 5;

/** VIB-2934: lenker med beskrivende navn, maks fem synlige. Redigeres i «Rediger». */
export function FreelancerLinksSection({ links }: { links: FreelancerListRow["links"] }) {
  const [all, setAll] = useState(false);
  if (links.length === 0) return null;
  const shown = all ? links : links.slice(0, VISIBLE);
  return (
    <SectionCard title="Lenker" compact meta={String(links.length)}>
      <ul className="flex flex-col gap-1.5 px-4 py-3">
        {shown.map((l) => {
          const host = linkLabelFromUrl(l.url);
          return (
            <li key={l.url} className="flex min-w-0 items-center gap-2 text-sm">
              <SrIcon name="external-link" className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
              <a href={l.url} target="_blank" rel="noreferrer" className="truncate font-medium text-primary hover:underline">{l.label}</a>
              {l.label !== host && <span className="shrink-0 text-xs text-muted-foreground">{host}</span>}
            </li>
          );
        })}
      </ul>
      {links.length > VISIBLE && (
        <div className="px-4 pb-3">
          <Button variant="link" size="sm" className="h-auto p-0 text-xs" onClick={() => setAll((v) => !v)}>
            {all ? "Vis færre" : `Vis ${links.length - VISIBLE} til`}
          </Button>
        </div>
      )}
    </SectionCard>
  );
}
